// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f384625e","703":"84ec2357","787":"7acb5043"}[chunkId] + ".chunk.js";
};